// =============================================================================
// Missions.tsx — Daily missions / challenges screen
// Project: Texas Hold'em Social Casino
// =============================================================================
// Shows the player's current daily missions and progress.
// Missions auto-reset each day and reward XP + chips on completion.

import React from 'react'
import { useUIStore } from '../store/ui-store'

const MISSIONS = [
  { id: 'play_10', label: 'Play 10 Hands', target: 10, reward: 500, icon: '♠' },
  { id: 'win_3', label: 'Win 3 Hands', target: 3, reward: 1000, icon: '🏆' },
  { id: 'flush', label: 'Win with a Flush', target: 1, reward: 2000, icon: '♦' },
  { id: 'all_in', label: 'Go All-In 5 Times', target: 5, reward: 800, icon: '🔥' },
]

export default function MissionsScreen(): React.ReactElement {
  const { navigateTo } = useUIStore()

  return (
    <div className="lobby">
      <div className="lobby-header">
        <button className="btn btn-secondary" style={{ padding: '6px 14px', fontSize: 12 }} onClick={() => navigateTo('lobby')}>
          ← Back
        </button>
        <div className="lobby-title">Daily Missions</div>
        <div style={{ width: 60 }} />
      </div>

      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
          Complete missions to earn bonus chips. Reset daily.
        </div>
        {MISSIONS.map(mission => (
          <div key={mission.id} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            background: 'rgba(255,255,255,0.05)', borderRadius: 12,
            padding: '14px 16px', marginBottom: 10,
            border: '1px solid rgba(255,255,255,0.08)',
          }}>
            <div style={{ fontSize: 28 }}>{mission.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>{mission.label}</div>
              <div style={{ fontSize: 12, color: '#888' }}>0 / {mission.target}</div>
              <div style={{
                height: 4, background: 'rgba(255,255,255,0.1)', borderRadius: 2,
                marginTop: 6, overflow: 'hidden',
              }}>
                <div style={{ width: '0%', height: '100%', background: '#f5c518', borderRadius: 2 }} />
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ color: '#f5c518', fontWeight: 700, fontSize: 13 }}>
                +{mission.reward}
              </div>
              <div style={{ fontSize: 10, color: '#888' }}>chips</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
